import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    signInView: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      color: '#232423',
      padding: '0 8px 32px 8px',
    },
    topLogo: {
      display: 'flex',
      justifyContent: 'center',
      margin: '50px 0 50px 0',
    },
    topText: {
      fontSize: '16px',
      fontWeight: 600,
      width: '100%',
      maxWidth: '300px',
      marginBottom: '40px',
    },
    accounts: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      maxWidth: '330px',
      '& .divider': {
        width: '100%',
        maxWidth: '330px',
        margin: '16px 0',
        backgroundColor: '#E9ECF0',
        borderBottom: '1px solid #E9ECF0',
      }
    },
    providers: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      marginBottom: '32px',
      width: '100%',
      maxWidth: '330px',
    },
    providerButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      maxWidth: '330px',
      border: `1px ${theme.semanticColors.disabledBorder} solid`,
      height: '46px',
      fontSize: '14px',
      fontWeight: 500,
      borderRadius: '4px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.semanticColors.buttonBackgroundHovered,
      },
      '& .icon': {
        padding: '0 8px',
        filter: 'saturate(80%)',
      },
      '& .text': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
      },
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '46px',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: theme.semanticColors.buttonBackgroundHovered,
      },
      cursor: 'pointer',
    }
  })
};
